import { Component, ElementRef, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Platform } from '@ionic/angular';

import { EventsService } from 'src/app/services/event/event.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { Navigator } from 'src/app/services/routing/navigator';
import { NavOverriderService } from 'src/app/services/navOverrider/nav-overrider.service';

@Component({
	selector: 'custom-navbar',
	templateUrl: './custom-navbar.component.html',
	styleUrls: ["./custom-navbar.component.scss"]
})
export class CustomNavbarComponent implements OnInit, OnDestroy {

	@ViewChild('theNavBar') theNavBar: ElementRef;

	@Input() extendCloseBtnFunction: any;
	@Input() hideBackButton: boolean;
	@Input() hideCloseButton: boolean;
	@Input() iconColor?: string;
	@Input() overrideBackBtnFunction: any;
	@Input() overrideCloseBtnFunction: any;
	@Input() smallSizeOnMobileWeb: boolean;
	@Input() titlelabel: string;
	@Input() toolbarColor?: string;

	private isMobileWeb: boolean = false;
	private navOverrideSubcriber;


	constructor(
		public navigator: Navigator,
		private platform: Platform,
		public eventsService: EventsService,
		public navOverride: NavOverriderService
	) { }

	ngOnInit(): void {
		try {
			if (this.navOverrideSubcriber) this.navOverrideSubcriber.unsubscribe();
		} catch {
			console.log('Subcription error');
		}
		this.isMobileWeb = this.platform.is('mobileweb');

		this.navOverrideSubcriber = this.navOverride
			.getCustomCloseFunction()
			.subscribe(customCloseFunction => {
				if (
					typeof customCloseFunction === 'function' ||
					customCloseFunction === undefined
				) {
					this.overrideCloseBtnFunction = customCloseFunction;
					//navOverride used only in marketing notification popover
					//override all close functions (back and close) to run next notification
					this.overrideBackBtnFunction = customCloseFunction;
				}
			});
	}

	onBack() {

		if (!isUndefined(this.overrideBackBtnFunction)) {
			try {
				return this.overrideBackBtnFunction();
			} catch {
				return this.navigator.back();
			}
		}

		return this.navigator.back();
	}


	onClose() {

		if (!isUndefined(this.overrideCloseBtnFunction)) {
			try {
				return this.overrideCloseBtnFunction();
			} catch (err) {
				return console.error(err);
			}
		}

		return this.onCloseDefault();
	}

	onCloseDefault() {
		if (!isUndefined(this.extendCloseBtnFunction)) {
			try {
				return this.extendCloseBtnFunction()
			}
			catch (error) {
				return console.error(error);
			}
		}
		return this.navigator.dismissAll();
	}

	ngOnDestroy() {
		try {
			this.navOverrideSubcriber?.unsubscribe();
		} catch (error) {
			console.error('Failed to unsubscribe Navbar:', error);
		}
	}

}
